module.exports = __webpack_public_path__ + "assets/img/creator-register.17c39bfb.png";